import { useFilterDisabledSettings } from "@api";
import { Autocomplete, TextField, autocompleteClasses } from "@mui/material";
import { useGlobalContext } from "@root/context";
import equal from "fast-deep-equal/react";
import { useEffect, useState } from "react";
import type { IAddParticipantFilters, IFilterInputProps } from "./types";

export const FilterStatus = ({ value, dispatch }: IFilterInputProps<IAddParticipantFilters["status"]>) => {
  const { settings } = useGlobalContext();

  const settingsStatus = useFilterDisabledSettings(settings?.statusCandidate ? settings.statusCandidate : []);

  const [localValue, setLocalValue] = useState(value);

  const handleDispatch = () => {
    if (!equal(localValue, value)) {
      dispatch({ type: "status", payload: localValue });
    }
  };

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <Autocomplete
      multiple
      options={settingsStatus}
      value={localValue}
      onBlur={handleDispatch}
      onChange={(_, status, reason) => {
        setLocalValue(status);
        if (reason === "removeOption") {
          dispatch({ type: "status", payload: status });
        }
      }}
      fullWidth
      renderInput={(params) => <TextField {...params} label="Statut" size="small" />}
      limitTags={2}
      slotProps={{
        chip: {
          color: "yellow",
          size: "small",
          sx: { [`&.${autocompleteClasses.tag}`]: { mt: "1px", mb: 0 } },
        }
      }}
    />
  );
};
